import { PermissionV2 } from '../permission/enum/PermissionV2';

export function getRouteDefaultRequiredLevel(route) {
    if (!route)
        return null;

    if (route.delete)
        return PermissionV2.delete;

    if (route.update)
        return PermissionV2.update;

    if (route.create)
        return PermissionV2.create;

    if (route.view)
        return PermissionV2.read;

    return null;
}
